import { render, staticRenderFns } from "./feed-list.vue?vue&type=template&id=482e907d"
import script from "./feed-list.vue?vue&type=script&lang=js"
export * from "./feed-list.vue?vue&type=script&lang=js"
import style0 from "./feed-list.vue?vue&type=style&index=0&id=482e907d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports